/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Venues_Delete_Reassign_RequiredInputs */

const cs_settings_venues_delete_reassign_required = /** @type {(inputs: Settings_Venues_Delete_Reassign_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberte pobočku, kam lidi přesunout.`)
};

const en_settings_venues_delete_reassign_required = /** @type {(inputs: Settings_Venues_Delete_Reassign_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a venue to move people to.`)
};

/**
* | output |
* | --- |
* | "Pick a venue to move people to." |
*
* @param {Settings_Venues_Delete_Reassign_RequiredInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_venues_delete_reassign_required = /** @type {((inputs?: Settings_Venues_Delete_Reassign_RequiredInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Venues_Delete_Reassign_RequiredInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_venues_delete_reassign_required(inputs)
	return cs_settings_venues_delete_reassign_required(inputs)
});